export default __webpack_public_path__ + "static/media/vehicle-check-wireframes.86a82635.jpg";